import methods from './methods'
import computed from './computed'
import data from './data'
import props from './props'
import mounted from './mounted'
import watch from './watch'

export default {
  data,
  props,
  methods,
  computed,
  mounted,
  watch
}



// WEBPACK FOOTER //
// ./src/app/professional/company/companies/components/tags/resources/index.js